<template>
  <v-app-bar color="primary">
    <div class="mr-2 logo-container">
      <v-avatar size="50" class="avatar-large" @click="$router.push('/')" style="cursor: pointer">
        <v-img
          contain
          :src="`data:application/jpg;base64,${company.base64Logo}`"
        />
      </v-avatar>
      <v-avatar size="36" class="avatar-small" @click="$router.push('/')" style="cursor: pointer">
        <v-img
          contain
          :src="`data:application/jpg;base64,${company.base64Logo}`"
        />
      </v-avatar>
    </div>
    <v-toolbar-title
      @click="$router.push('/')"
      class="text-lg-h5 font-weight-black white--text ml-4 toolbar-title"
      style="cursor: pointer"
    >
      <span class="mr-2 company-name">{{ company.displayName }}</span>
      <span class="events-text">EVENTS</span>
    </v-toolbar-title>
    <v-spacer />
    
    <!-- Full button for larger screens -->
    <v-btn 
      class="primary mx-2 booking-btn-full" 
      text 
      v-if="check" 
      link 
      @click="goToBookingList"
    >
      Click to View My Bookings
    </v-btn>
    
    <!-- Icon button for small screens -->
    <v-btn 
      class="primary booking-btn-small" 
      icon 
      v-if="check" 
      @click="goToBookingList"
      title="View My Bookings"
    >
      <v-icon color="white">mdi-calendar-check</v-icon>
    </v-btn>
    
    <span v-if="check" class="overline mr-4 h4 white--text welcome-text">
      Welcome {{ user.name }}
    </span>
    
    <!-- Full logout button for larger screens -->
    <v-btn v-if="check" color="white" text @click="logout" class="logout-btn-full">
      Logout
    </v-btn>
    
    <!-- Icon logout button for small screens -->
    <v-btn v-if="check" icon @click="logout" class="logout-btn-small" title="Logout">
      <v-icon color="white">mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { AuthService } from "../modules/auth";

export default {
  name: "AppHeader",
  mounted() {
    document.onkeydown = (e) => {
      if (e.ctrlKey === true && e.keyCode === 76) {
        e.preventDefault();
        console.log("ctrl + l was hit ....");
        this.login();
      }
    };
    Event.$on("goBack", () => {
      this.$router.push({ name: "EventList" });
    });
  },
  computed: {
    user() {
      return AuthService.user;
    },
    check() {
      return AuthService.check();
    },
    company() {
      return this.$store.getters["Auth/company"];
    },
  },
  methods: {
    login: function () {
      Event.$emit("login-form", true);
    },
    logout: function () {
      this.$store.dispatch("Auth/logout", {
        id: AuthService.user.id,
      });
    },
    goToBookingList: function () {
      this.$router.push({ name: "BookingList" });
    },
  },
};
</script>

<style scoped>
/* Default: Show full elements, hide small screen versions */
.avatar-small {
  display: none;
}

.booking-btn-small {
  display: none;
}

.logout-btn-small {
  display: none;
}

/* Small screens up to 320px */
@media screen and (max-width: 320px) {
  /* Avatar adjustments */
  .avatar-large {
    display: none;
  }

  .avatar-small {
    display: flex;
  }

  .logo-container {
    margin-right: 4px !important;
  }

  /* Toolbar title adjustments */
  .toolbar-title {
    margin-left: 4px !important;
    font-size: 0.85rem !important;
  }

  .company-name {
    display: none;
  }

  .events-text {
    font-size: 0.9rem;
  }

  /* Hide full buttons, show icon buttons */
  .booking-btn-full {
    display: none;
  }

  .booking-btn-small {
    display: flex;
    margin: 0 2px;
  }

  .welcome-text {
    display: none;
  }

  .logout-btn-full {
    display: none;
  }

  .logout-btn-small {
    display: flex;
  }
}

/* Medium small screens (321px - 480px) */
@media screen and (min-width: 321px) and (max-width: 480px) {
  .avatar-large {
    display: none;
  }

  .avatar-small {
    display: flex;
  }

  .toolbar-title {
    margin-left: 8px !important;
    font-size: 0.95rem !important;
  }

  .company-name {
    display: none;
  }

  .booking-btn-full {
    display: none;
  }

  .booking-btn-small {
    display: flex;
    margin: 0 4px;
  }

  .welcome-text {
    display: none;
  }

  .logout-btn-full {
    display: none;
  }

  .logout-btn-small {
    display: flex;
  }
}
</style>